import { render } from "./OkCancel.vue?vue&type=template&id=2b48ea64&scoped=true"
import script from "./OkCancel.vue?vue&type=script&lang=js"
export * from "./OkCancel.vue?vue&type=script&lang=js"

import "./OkCancel.vue?vue&type=style&index=0&id=2b48ea64&scoped=true&lang=css"
import "./OkCancel.vue?vue&type=style&index=1&id=2b48ea64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b48ea64"]])

export default __exports__